<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
			<span class="visually-hidden">Loading...</span>
		</div>

		<div class="container flex-grow-1 container-p-y" v-if="!isLoading" style="padding-top: 0px !important;">
			<div v-if="!selectedTraining" class="row">
				<div class="col-md-12 mb-5 mt-10">
					<div class="card h-100">
						<div class="card-body pb-4">
							<div class="mb-0">
								<div class="d-flex align-items-center">
									<div class="avatar avatar-md">
										<div class="avatar-initial bg-label-primary rounded-3">
											<i class="ri-bank-card-line ri-24px"></i>
										</div>
									</div>
									<div class="ms-4">
										<p class="mb-0">
											{{ $t('trainings.catalog.welcome') }}
											<br />
											{{ $t('trainings.catalog.customNote') }}
											<a href="mailto:contact@pika-aero.com">contact@pika-aero.com</a>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-12 col-xxl-4 col-lg-4 pb-20" v-for="(training, index) in sortedTrainings" :key="index">
					<div class="card h-100 d-flex flex-column">
						<img class="card-img-top" :src="training.previewUrl[0].url" alt="iPhone-bg" />
						<div class="card-body d-flex flex-column flex-grow-1">
							<div class="flex-grow-1">
								<p class="mb-6">
									{{ training.description }}
								</p>
							</div>
							<div class="row mb-6 g-6">
								<div class="col-6">
									<div class="d-flex">
										<div class="avatar flex-shrink-0 me-4">
											<span class="avatar-initial rounded-3 bg-label-primary"
												><i class="ri-calendar-line ri-24px"></i
											></span>
										</div>
										<div>
											<h6 class="mb-0 text-nowrap fw-normal">
												{{ training.validityInYears }} an{{ training.validityInYears > 1 ? 's' : '' }}
											</h6>
											<small>{{ $t('common.validity') }}</small>
										</div>
									</div>
								</div>
								<div class="col-6">
									<div class="d-flex">
										<div class="avatar flex-shrink-0 me-4">
											<span class="avatar-initial rounded-3 bg-label-primary"
												><i class="ri-time-line ri-24px"></i
											></span>
										</div>
										<div>
											<h6 class="mb-0 text-nowrap fw-normal">
												{{
													training.durationInHours < 1
													? Math.round(training.durationInHours * 60) + ' minute' + (Math.round(training.durationInHours * 60) > 1 ? 's' : '')
													: formatDuration(training.durationInHours)
												}}
											</h6>
											<small>{{ $t('common.duration') }}</small>
										</div>
									</div>
								</div>
							</div>
							<a 
								href="javascript:void(0);"
								class="btn btn-primary w-100"
								@click="redirectToRegister()"
								v-if="training.isAvailable"
							>
								{{ $t('trainings.catalog.orderTraining', { price: training.price * 5 }) }}
							</a>
							<a href="javascript:void(0);" class="btn btn-label-secondary w-100" v-else disabled="true">
								{{ $t('trainings.create.comingSoon') }}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";


export default {
	name: "TrainingCreate",

	data() {
		return {
			search: null,
			company: null,
			taxes: 0,
			priceWithoutTaxes: 0,
			isLoading: true,
			selectedTraining: null,
			selectedType: null,
			displayEmployees: false,
			employees: [],
			selectedEmployees: [],
			trainings: [],
			isWaitingStripe: false,
			form: {
				firstName: "",
				lastName: "",
				email: "",
				birthDate: null,
				role: "trainee"
			},
			errors: {},
		};
	},

	methods: {
		redirectToRegister() {
			this.$router.push("/register");
		},

		formatDuration(hours) {
			const fullHours = Math.floor(hours)
			const minutes = Math.round((hours - fullHours) * 60)

			if (minutes === 0)
				return `${fullHours} heures`
				
			return `${fullHours}h${minutes}`
		},

		async fetchTrainings() {
			try {
				const response = await HTTP('/trainings');
				this.trainings = response.data.formations;
				this.isLoading = false;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},
	},

	async mounted() {
		this.fetchTrainings();
	},

	computed: {
		sortedTrainings() {
			// Trie les formations par `order`
			return [...this.trainings].sort((a, b) => a.order - b.order);
		}
	}
};
</script>

<style scoped>
.load-center {
	display: block;
	margin: 0 auto;
}

/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.modal-simple .modal-content {
	padding: 3rem;
}

.pb-20 {
	padding-bottom: 20px;
}
</style>
